export default __webpack_public_path__ + "static/media/event-2.890a8faf.JPG";